var _circle, _path, _rect, _rect2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArAgingDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F0EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.714 19h15.759a3 3 0 0 1 1.937.71l9.527 8.058A3 3 0 0 1 55 30.058v25.109c0 3.58-.04 3.833-3.714 3.833H26.714C23.041 59 23 58.748 23 55.167V22.833c0-3.58.04-3.833 3.714-3.833Z",
    fill: "#A0C9BF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 37,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#006C52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 45,
    width: 10,
    height: 4,
    rx: 2,
    fill: "#006C52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 39.25a2.25 2.25 0 0 0-2.25 2.25v2.796c0 .727.35 1.409.942 1.831l6.123 4.373-6.123 4.373a2.25 2.25 0 0 0-.942 1.83V59.5a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25v-2.796a2.25 2.25 0 0 0-.942-1.831L57.435 50.5l6.123-4.373a2.25 2.25 0 0 0 .942-1.83V41.5a2.25 2.25 0 0 0-2.25-2.25h-13.5Z",
    fill: "#006C52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 59.024a.476.476 0 0 1-.476.476h-8.048a.476.476 0 0 1-.476-.476c0-.402.214-.773.562-.974l2.813-1.624a2.25 2.25 0 0 1 2.25 0l2.813 1.624c.348.2.562.572.562.974Z",
    fill: "#A0C9BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArAgingDetail);
export default __webpack_public_path__ + "static/media/ar-aging-detail.2c5859e6.svg";
export { ForwardRef as ReactComponent };